// extracted by mini-css-extract-plugin
export default {"root":"RequestLinks_root__2VkNQ","link":"RequestLinks_link__pJyiX","counter":"RequestLinks_counter__xx+8Y"};